import { SIMILR_PRODUCTS_ACTIONS } from './constants';

const initialState = {
  deviceList: [],
  header: 'Похожие товары',
  addedDeviceId: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SIMILR_PRODUCTS_ACTIONS.SET_SIMILR_PRODUCTS: {
      return {
        ...state,
        deviceList: action.payload,
      };
    }
    case SIMILR_PRODUCTS_ACTIONS.SIMILR_PRODUCTS_ACTIONS: {
      return {
        ...state,
        addedDeviceId: action.payload,
      };
    }
    case SIMILR_PRODUCTS_ACTIONS.SET_SIMILR_PRODUCTS_IS_FAVORITE_DEVICE: {
      const devices = [...state.deviceList];
      const favoriteDevices = [...action.payload];

      const deviceList = devices.map((device) => ({
        ...device,
        isFavorite: favoriteDevices.includes(device.id),
      }));

      return {
        ...state,
        deviceList,
      };
    }
    case SIMILR_PRODUCTS_ACTIONS.SET_SIMILR_PRODUCTS_IS_CMP_DEVICE: {
      const devices = [...state.deviceList];

      const deviceList = setDeviceCurField(devices, action.payload, 'isCmp');

      return {
        ...state,
        deviceList,
      };
    }
    default:
      return state;
  }
};

const setDeviceCurField = (data, id, field) =>
  data.reduce((acc, cur) => {
    const device = cur.id === id ? { ...cur, [field]: !cur[field] } : cur;

    acc.push(device);

    return acc;
  }, []);
